export default __webpack_public_path__ + "static/media/promo_02.0cc88391.jpg";